import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import * as Sentry from '@sentry/browser';
import { ErrorBoundary } from '@app/modules/application';
import { App } from './App';
import './styles/index.scss';
import '@incodocs/template-view/dist/stlyes/layout/index.css';
import '@incodocs/template-view/dist/stlyes/print/index.css';
import '@incodocs/template-view/dist/stlyes/edit/index.css';
import 'react-contexify/dist/ReactContexify.min.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-datepicker/dist/react-datepicker.css';

if (process.env.REACT_APP_STAGE === 'production') {
  // TODO
  // change to own sentry project
  Sentry.init({
    dsn: 'https://8f5e9c7034e84ba9ae25ebf959c446f9@sentry.io/1453759',
  });
}

ReactDOM.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
